import { useCallback, useEffect, useState } from 'react';

interface UsePDFFormStateOptions {
  initialFormData?: Record<string, string | boolean | string[]>;
  onFormDataChange?: (
    formData: Map<string, string | boolean | string[]>,
  ) => void;
}

export const usePDFFormState = ({
  initialFormData,
  onFormDataChange,
}: UsePDFFormStateOptions = {}) => {
  const [formData, setFormData] = useState<
    Map<string, string | boolean | string[]>
  >(() => new Map(Object.entries(initialFormData ?? {})));

  const handleFieldChange = useCallback(
    (
      fieldId: string,
      value: string | boolean | string[],
      fieldTypeMapping: Map<string, string>,
      fieldRadioGroupMapping: Map<string, string>,
    ) => {
      setFormData((prev) => {
        const newFormData = new Map(prev);

        if (typeof value === 'boolean' && value === true) {
          const fieldType = fieldTypeMapping.get(fieldId);
          if (fieldType === 'radio') {
            const radioGroup = fieldRadioGroupMapping.get(fieldId);
            if (radioGroup) {
              fieldRadioGroupMapping.forEach((groupName, radioFieldId) => {
                if (groupName === radioGroup && radioFieldId !== fieldId) {
                  newFormData.set(radioFieldId, false);
                }
              });
            }
          }
        }

        newFormData.set(fieldId, value);
        onFormDataChange?.(new Map(newFormData));
        return newFormData;
      });
    },
    [onFormDataChange],
  );

  useEffect(() => {
    setFormData(new Map(Object.entries(initialFormData ?? {})));
  }, [initialFormData]);

  return {
    formData,
    setFormData,
    handleFieldChange,
  };
};
